/**
 * Checks if the current window is an MSAL popup returning from Microsoft
 * with an auth response. Uses the `state` param instead of `window.opener`
 * (which gets nulled by Microsoft's COOP header).
 */
export function isMsalPopupResponse(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  const hash = window.location.hash;
  const search = window.location.search;

  const authIndicators = ['code=', 'error=', 'id_token=', 'access_token='];

  const hasAuthResponse = authIndicators.some(
    (indicator) => search.includes(indicator) || hash.includes(indicator)
  );

  if (!hasAuthResponse) {
    return false;
  }

  try {
    const hashParams =
      hash.length > 1 ? new URLSearchParams(hash.substring(1)) : null;
    const searchParams = search.length > 1 ? new URLSearchParams(search) : null;
    const state = hashParams?.get('state') ?? searchParams?.get('state');

    if (!state) {
      return false;
    }

    const libraryStatePart = state.split('|')[0];
    const base64 = libraryStatePart.replace(/-/g, '+').replace(/_/g, '/');
    const decoded = JSON.parse(atob(base64));

    const interactionType = decoded.meta?.interactionType;

    return interactionType === 'popup' || interactionType === 'silent';
  } catch {
    return false;
  }
}
